import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import cs from '../../../../components/commonStyle.css';
import s from './PreviewModal.css';

class PreviewModal extends React.Component {
    render() {
        const { show, closePreviewModal, layout, previewLabel } = this.props;
        return (
            <Modal show={show} onHide={closePreviewModal} dialogClassName={cx('commonModalContainer', s.siteSettingPreviewModel)}>
                <Modal.Header closeButton className='commonModalHeader'>
                    <Modal.Title className='commonModalTitle'> {previewLabel}</Modal.Title>
                </Modal.Header>
                <Modal.Body bsClass='commonModalBody'>
                    <div>
                        <img src={layout[0]} alt={layout[0]} className={s.previewModelImage} />
                    </div>
                </Modal.Body>
            </Modal >)
    }
}
const mapState = state => ({});
const mapDispatch = {};
export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(PreviewModal)));